"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleClient = void 0;
const commons_utils_1 = require("@deliverr/commons-utils"); /* eslint-disable @typescript-eslint/no-unused-vars */
const core_client_1 = require("@deliverr/core-client");
const openapi_1 = require("./generated-sources/openapi");
const core_auth_1 = require("@deliverr/core-auth");
class WholesaleClient extends core_client_1.OpenApiGeneratedClient {
    instantiateOpenApiGeneratedApi() {
        //client uses the axios instance created by core client, to avoid compatibility issues
        return new openapi_1.ServiceApi(new openapi_1.Configuration(this.getConfigurationParameters()), undefined, this.axios);
    }
    getDefaultServiceUrlEnvKey() {
        return "WHOLESALE_API_URL";
    }
    static initDefaultClient() {
        const url = (0, commons_utils_1.getEnvString)("WHOLESALE_API_URL");
        const username = (0, commons_utils_1.getEnvString)("WHOLESALE_USERNAME");
        const password = (0, commons_utils_1.getEnvString)("WHOLESALE_PASSWORD");
        const auth = { basicAuthUser: username, basicAuthPassword: password };
        const config = Object.assign(Object.assign({ baseURL: url }, auth), { authEngine: core_auth_1.AuthEngine.BASIC });
        return new WholesaleClient(config);
    }
    constructor(config) {
        super(config);
    }
    getShipmentsV2(getShipmentsParams, options) {
        return this.wrapClientOperationExecution(async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return this.getOpenApiGeneratedApi().getShipmentsV2(getShipmentsParams.projectionKeys, (_a = getShipmentsParams.inFilter) === null || _a === void 0 ? void 0 : _a.status, (_b = getShipmentsParams.inFilter) === null || _b === void 0 ? void 0 : _b.originWarehouseId, (_c = getShipmentsParams.inFilter) === null || _c === void 0 ? void 0 : _c.wholesaleOrderId, (_d = getShipmentsParams.inFilter) === null || _d === void 0 ? void 0 : _d.shippingMethod, (_e = getShipmentsParams.inFilter) === null || _e === void 0 ? void 0 : _e.shipmentType, (_f = getShipmentsParams.orderBy) === null || _f === void 0 ? void 0 : _f.column, (_g = getShipmentsParams.orderBy) === null || _g === void 0 ? void 0 : _g.direction, (_h = getShipmentsParams.pagination) === null || _h === void 0 ? void 0 : _h.limit, (_j = getShipmentsParams.pagination) === null || _j === void 0 ? void 0 : _j.offset, (_k = getShipmentsParams.byExternalAttribute) === null || _k === void 0 ? void 0 : _k.attributeName, (_l = getShipmentsParams.byExternalAttribute) === null || _l === void 0 ? void 0 : _l.attributeValue, getShipmentsParams.eventVisibility, options);
        });
    }
    /**
     *
     * @param {string} fulfillmentId
     * @param {string} [xDeliverrSellerId]
     * @param orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options);
        });
    }
    /**
     *
     * @param {string} shipmentId
     * @param {AttachmentType} attachmentType
     * @param {attachmentMetaDate} attachmentMetaDateDTO
     * @param {string} [orderId]
     * @param {string} [sellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, sellerId, attachmentMetaDate, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, sellerId, attachmentMetaDate, options);
        });
    }
    /**
     *
     * @param {string} shipmentId
     * @param {AttachmentType} attachmentType
     * @param {string} [orderId]
     * @param {string} [sellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options);
        });
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {boolean} [submitOrder]
     * @param {boolean} [validateAddress]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options);
        });
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {boolean} [submitOrder]
     * @param {boolean} [validateAddress]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options);
        });
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options);
        });
    }
    /**
     * returns the avialble inventory for a given SKU list in context of a specific sourceWarehouse and destinationChannelId
     * @summary get available inventory for a given SKU
     * @param {Array<string>} dskus the list of SKUs to be searched for inventory
     * @param {ExternalDestinationType} [targetId] the target to search for inventory
     * @param {Array<string>} [sourceWarehouses] warehouseIds to search for inventory
     * @param {InventoryPool} [inventoryPool] choose what kind of inventory pool to use (Defaults to STORAGE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param visibility
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrderAndShipments(orderId, eventVisibility, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options);
        });
    }
    /**
     *
     * @param {string} shipmentId
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options);
        });
    }
    /**
     *
     * @param {WholesaleOrderStatus} [orderStatus]
     * @param externalDestinationType
     * @param externalId
     * @param {boolean} [includeArchived]
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} shipmentId
     * @param {string} [xDeliverrSellerId]
     * @param eventVisibility
     * @param skipAttachmentByWarehouseType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipment(orderId, shipmentId, eventVisibility, xDeliverrSellerId, skipAttachmentByWarehouseType, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options);
        });
    }
    /**
     *
     * @param {string} shipmentId
     * @param {string} [xDeliverrSellerId]
     * @param orderId
     * @param eventVisibility
     * @param orderId
     * @param eventVisibility
     * @param skipAttachmentByWarehouseType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} shipmentId
     * @param {WholesaleShipmentPatchDTO} wholesaleShipmentsPatchDTO
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchShipment(orderId, shipmentId, wholesaleShipmentsPatchDTO, xDeliverrSellerId, options, shouldRerunEstimations) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().patchShipmentAdminAccess(shipmentId, wholesaleShipmentsPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options);
        });
    }
    /**
     *
     * @param {string} shipmentId
     * @param {WholesaleShipmentPatchDTO} wholesaleShipmentsPatchDTO
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchShipmentAdminAccess(shipmentId, wholesaleShipmentsPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().patchShipmentAdminAccess(shipmentId, wholesaleShipmentsPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} shipmentId
     * @param {attachmentType} AttachmentType
     * @param {string} [xDeliverrSellerId]
     * @param {AttachmentMetaDataDTO} [attachmentMetaDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    requestLabelUpload(orderId, shipmentId, attachmentType, xDeliverrSellerId, attachmentMetaDate, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDate, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options);
        });
    }
    /**
     * @deprecated
     **/
    overrideShipments(orderId, WholesaleSingleShipmentCreationRequestDTO, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().overrideShipments(orderId, WholesaleSingleShipmentCreationRequestDTO, xDeliverrSellerId, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    cancelOrderAndShipments(orderId, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().cancelOrderAndShipments(orderId, xDeliverrSellerId, options);
        });
    }
    /**
     *
     * @param {ExternalDestinationType} externalDestinationType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getValidAttributesV2(externalDestinationType, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getValidAttributesV2(externalDestinationType, options);
        });
    }
    /**
     *
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {boolean} [validateAddress]
     * @param {*} [options] Override http request option.
     * @param {boolean} [partialFill]
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options);
        });
    }
    /**
     * @param {string} orderId
     * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
     * @param {*} [options] Override http request option.
     */
    patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO);
        });
    }
    /**
     * @param {string} orderId
     * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
     * @param {*} [options] Override http request option.
     */
    patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO);
        });
    }
    /**
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
     * @param {*} [options] Override http request option.
     */
    patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options);
        });
    }
    cancelTransferAndShipments(transferId, xDeliverrSellerId, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().cancelTransferAndShipments(transferId, xDeliverrSellerId);
        });
    }
    createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options);
        });
    }
    augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options);
        });
    }
    getValidShipBy(shipmentId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getValidShipBy(shipmentId);
        });
    }
    getValidShipByV2(originWarehouseId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getValidShipByV2(undefined, originWarehouseId);
        });
    }
    getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options);
        });
    }
    validateAddress(deliverrAddress, fetchValidatedAddress) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().validateAddress(fetchValidatedAddress, deliverrAddress);
        });
    }
    purchaseLabel(purchaseLabelRequest) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().purchaseLabel(purchaseLabelRequest);
        });
    }
    generateCaseLabelPdf(purchaseLabelRequest) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generateCaseLabelPdf(purchaseLabelRequest);
        });
    }
    printCaseLabelPdf(shipmentId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().printCaseLabelPdf(shipmentId);
        });
    }
    releaseShipments(releaseShipmentsDTO) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().releaseShipments(releaseShipmentsDTO);
        });
    }
}
exports.WholesaleClient = WholesaleClient;
//# sourceMappingURL=WholesaleClient.js.map